import React from "react";
import { Button, Modal } from "antd";

interface BasicActionModalProps {
  showModal: boolean;
  onClose: () => void;
  content?: React.ReactNode;
  title?: React.ReactNode;
  textOk: string;
  functionOk: () => void;
  loadingCancel?: boolean;
  disabledCancel?: boolean;
  loadingOk?: boolean;
  disabledOk?: boolean;
  okDanger?: boolean;
}

const BasicActionModal: React.FC<BasicActionModalProps> = ({
  showModal,
  onClose,
  content,
  title,
  textOk,
  functionOk,
  loadingCancel,
  disabledCancel,
  loadingOk,
  disabledOk,
  okDanger,
}) => {
  return (
    <Modal
      title={title}
      open={showModal}
      onCancel={onClose}
      footer={[
        <Button
          key="ok"
          type="primary"
          danger={okDanger}
          onClick={functionOk}
          disabled={disabledOk}
          loading={loadingOk}
        >
          {textOk}
        </Button>,
        <Button key="cancel" onClick={onClose} disabled={disabledCancel} loading={loadingCancel}>
          Cancel
        </Button>,
      ]}
    >
      {content}
    </Modal>
  );
};
export default BasicActionModal;
